import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("package/index"),
  
  store: (userData) => clientAuth.post('package/store', { json: userData }),
  

  show:(id)=>clientAuth.get('package/show/'+id),

  update:(id,userData)=>clientAuth.post('package/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`package/destroy/${id}`),


  //packagesItems

  packageItemIndex: () => clientAuth.get("packageItem/index"),
  
  packageItemstore: (userData) => clientAuth.post('packageItem/store', { json: userData }),
  

  packageItemshow:(id)=>clientAuth.get('packageItem/show/'+id),

  
  packageItemdestroy:(id)=>clientAuth.delete(`packageItem/destroy/${id}`),
  packageItem:(id,userData)=>clientAuth.post('packageItem/update/'+id,{json:userData}),

  
};